<template>
  <div class="hero-full-content" :class="{'is-open': isOpen}">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "HeroFullContent",
    props: {
      isOpen: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .hero-full-content {
    position: absolute;
    width: 50%;
    padding: 70px 60px 0;
    transform: translateY(-1000px);
    opcity: 0;
    right: 0;
    top: 0;
    transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);

    &.is-open {
      opacity: 1;
      height: 100%;
      transform: translateY(0);
    }
  }

  @media (min-width: $breakpoint-sm-min) {
    .hero-full-content {
      padding: 10px 0;
    }
  }

  @media (min-width: $breakpoint-md-min) {
    .hero-full-content {
      padding: 30px 0 0;
    }
  }

  @media (min-width: $breakpoint-lg-min) {
    .hero-full-content {
      padding: 50px 30px 0;
    }
  }
  @media (min-width: $breakpoint-xl-min) {
    .hero-full-content {
      padding: 70px 60px 0;
    }
  }
</style>
